export default __webpack_public_path__ + "static/media/icon-risk.2b084fe5.svg";